import React from 'react'
import { withRouter } from 'react-router-dom'
import { view } from 'react-easy-state'
import { Row, Col, Tooltip, Progress, Avatar } from 'antd'

const ChapterList = (props) => {

  const { chapters } = props

  console.log('ChapterList: chapters:', chapters)

  const chapterColSpans = {
    xs: { span: 24, },
    sm: { span: 8 },
    md: { span: 6 },
  }

  const handleChapterCardClick = (chapterId) => {
    props.history.push(`/chapters/${chapterId}`)
  }

  if (!chapters || chapters.length === 0) {
    return <div className="course-list no-course">No chapter found</div>
  }

  return (
    <div className="course-list">
      <Row gutter={20}>
        {
          chapters.map(chapter => (
            <Col key={chapter.id} {...chapterColSpans} className="m-t-20">
              <div className="course-item-card" onClick={() => handleChapterCardClick(chapter.id)}>
                <div className="course-image square-image">
                  <div style={{ backgroundImage: `url("${chapter.image_url}")` }}></div>
                </div>
                <div className="course-info">
                  <Tooltip placement="top" title={chapter.name} arrowPointAtCenter>
                    <div className="course-title">{chapter.name}</div>
                  </Tooltip>
                  {
                    false && <Progress
                      strokeColor={{
                        '0%': '#108ee9',
                        '100%': '#87d068',
                      }}
                      percent={chapter.userProgress || 0}
                      strokeWidth={12}
                      showInfo={false}
                      style={{ margin: '15px 0px' }}
                    />
                  }

                  {
                    false && <div className="course-states">
                      <div className="course-auther">
                        <Avatar src={`https://i.pravatar.cc/150?u=${chapter.id}`} /> <span>{chapter.instructor && chapter.instructor[0] && chapter.instructor[0].name}</span>
                      </div>
                      <div className="course-completed">
                        <strong>{chapter.userProgress || 0}%</strong>
                        <span> Completed</span>
                      </div>
                    </div>
                  }

                </div>
              </div>
            </Col>
          ))
        }
      </Row>
    </div>
  )

}

export default withRouter(view(ChapterList))
